// Price-list API integration boundary. Uses the shared, CSRF/auth-aware api client.
// Authoritative pricing stays in the backend; this only centralizes endpoints/requests.
import { api } from "@/lib/api";

export const priceListService = {
  list: () => api.get("/price-lists").then((r) => r.data),
  get: (id) => api.get(`/price-lists/${id}`).then((r) => r.data),
  create: (body) => api.post("/price-lists", body).then((r) => r.data),
  update: (id, body) => api.put(`/price-lists/${id}`, body).then((r) => r.data),
  remove: (id) => api.delete(`/price-lists/${id}`).then((r) => r.data),
  addPrice: (plId, body) => api.post(`/price-lists/${plId}/prices`, body).then((r) => r.data),
  updatePrice: (plId, priceId, body) => api.put(`/price-lists/${plId}/prices/${priceId}`, body).then((r) => r.data),
  removePrice: (plId, priceId) => api.delete(`/price-lists/${plId}/prices/${priceId}`).then((r) => r.data),
};
